
import { SettingsUsers, SettingsUserSeatStatus, initialState } from './users.state';
import { SettingsUsersActions, SettingsUsersActionType } from './users.actions';
import { HttpStatus } from '@core/classes/http-status.class';
import { HttpRequestStatus } from '@core/classes/http-request-status.class';

export function settingsUsersReducer(state = initialState, action: SettingsUsersActions): SettingsUsers {
    switch (action.type) {
		// EVENTS STATUS

		// Users
		case SettingsUsersActionType.LoadAllUsers:
			return {...state, status: { ...state.status, list: new HttpStatus(HttpStatus.PENDING, "")}};

		case SettingsUsersActionType.LoadAllUsersSuccess:
			return {...state, status: { ...state.status, list: new HttpStatus(HttpStatus.DONE, "")}};

		case SettingsUsersActionType.LoadAllUsersError:
			return {...state, status: { ...state.status, list: new HttpStatus(HttpStatus.ERROR, "")}};

		// Seats
		case SettingsUsersActionType.LoadAllUsersSeats:
			return {...state, status: { ...state.status, seatsList: new HttpStatus(HttpStatus.PENDING, "")}};

		case SettingsUsersActionType.LoadAllUsersSeatsSuccess:
			return {...state, status: { ...state.status, seatsList: new HttpStatus(HttpStatus.DONE, "")}};

		case SettingsUsersActionType.LoadAllUsersSeatsError:
			return {
				...state,
				status: {
					...state.status,
					seatsList: new HttpStatus(HttpStatus.ERROR, action.error.status.toString())
				}};

		// AddInvitation
		case SettingsUsersActionType.AddNewInvitation:
			return {...state, status: { ...state.status, addInvite: new HttpRequestStatus(HttpRequestStatus.PENDING, "")}};

		case SettingsUsersActionType.AddNewInvitationSuccess:
			return {...state, status: { ...state.status, addInvite: new HttpRequestStatus(HttpRequestStatus.DONE, "")}};

		case SettingsUsersActionType.AddNewInvitationError:
			return {
				...state,
				status: {
					...state.status,
					addInvite: new HttpStatus(HttpStatus.ERROR, action.error.status.toString())
				}};

		case SettingsUsersActionType.ClearAddInvitation:
			return {...state, status: { ...state.status, addInvite: new HttpRequestStatus(HttpRequestStatus.READY, "")}};

		// DeleteUser
		case SettingsUsersActionType.DeleteOneUser:
			return {...state, 
				status: { ...state.status, delUser: new HttpRequestStatus(HttpRequestStatus.PENDING, "")},
				seats: state.seats.filter((seat) => seat.status == SettingsUserSeatStatus.USER_SEAT_ASSIGNED ? seat.user.id !== action.id : true),
			};

		case SettingsUsersActionType.DeleteOneUserSuccess:
			return {...state, status: { ...state.status, delUser: new HttpRequestStatus(HttpRequestStatus.DONE, "")}};

		case SettingsUsersActionType.DeleteOneUserError:
			return {...state, status: { ...state.status, delUser: new HttpRequestStatus(HttpRequestStatus.ERROR, "")}};
			
		case SettingsUsersActionType.ClearDeleteUSer:
			return {...state, status: { ...state.status, delUser: new HttpRequestStatus(HttpRequestStatus.READY, "")}};

		// DeleteInvitation
		case SettingsUsersActionType.DeleteInvitation:
			return {...state, 
				status: { ...state.status, 
					delInvite: new HttpRequestStatus(HttpRequestStatus.PENDING, "")
				},
				// filter a pending seat by email
				seats: state.seats.filter((seat) => seat.status == SettingsUserSeatStatus.USER_SEAT_PENDING ? seat.user.email !== action.email : true),
			};

		case SettingsUsersActionType.DeleteInvitationSuccess:
			return {...state, status: { ...state.status, delInvite: new HttpRequestStatus(HttpRequestStatus.DONE, "")}};

		case SettingsUsersActionType.DeleteInvitationError:
			return {...state, status: { ...state.status, delInvite: new HttpRequestStatus(HttpRequestStatus.ERROR, "")}};
		
		case SettingsUsersActionType.ClearDeleteInvitation:
			return {...state, status: { ...state.status, delInvite: new HttpRequestStatus(HttpRequestStatus.READY, "")}};
		
			case SettingsUsersActionType.SetAllUsers:
			return {
				...state,
				users: action.users
			};

		// case SettingsUsersActionType.SetAllInvitations:

            // let deleted = state.invitations.filter(i => action.invitations.indexOf(i) < 0);
            // let added   = action.invitations.filter(i => state.invitations.indexOf(i) < 0);
            //
            // console.log(deleted, added);
            //
            // for(let e of deleted) {
            //     var i = state.invitations.indexOf(e);
            //     state.invitations.splice(i, 1);
            // }
            //
            // //state.invitations.concat(added);
            // for(let e of added) {
            //     state.invitations.push(e);
            // }
            //
            // return state;

			// return {
			// 	...state,
			// 	invitations: action.invitations
			// };

			// SEATS
			case SettingsUsersActionType.SetAllUsersSeats:
				return {
					...state,
					seats: action.seats
				};

	    default:
	        return state;
    }
}
